export const BUTTON_CIRCLE_ACTIONS_TO_ICON = Object.freeze({
  close: 'regular-xmark',
  ellipsis: 'regular-ellipsis',
  expand: 'regular-list',
  pin: 'regular-thumbtack',
  add: 'regular-circle-plus',
});

export const BUTTON_LIGHT_ACTIONS_TO_ICON = Object.freeze({
  create: 'solid-plus',
});

export const BUTTON_LINK_ACTIONS_TO_ICON = Object.freeze({
  other_page: 'solid-forward',
});

export const BUTTON_SECONDARY_ACTIONS_TO_ICON = Object.freeze({
  arrow_down: 'solid-arrow-down',
  arrow_up: 'solid-arrow-up',
  create: 'solid-plus',
  download: 'solid-download',
  downloading: 'solid-spinner',
  loading: 'solid-spinner',
  edit: 'solid-pen-to-square',
  preview: 'regular-eye',
  save: 'solid-save',
  unpublish: 'regular-eye-slash',
  upload: 'solid-upload',
  unlock: 'regular-unlock',
  share: 'solid-share',
  template: 'regular-memo',
  new: 'solid-plus',
  info: 'regular-circle-info',
  lock: 'regular-lock',
  settings: 'regular-gear',
  reset: 'regular-rotate-left',
});

export const BUTTON_TERTIARY_ACTIONS_TO_ICON = Object.freeze({
  cancel: 'regular-xmark',
  clear_filters: 'regular-filter-slash',
  previous: 'solid-chevron-left',
  next: 'solid-chevron-right',
  create: 'solid-plus',
  filter: 'regular-bars-filter',
  seen_by: 'regular-eye',
  shared_with: 'solid-users',
  company: 'solid-building',
  sign_out: 'solid-right-from-bracket',
  upload: 'solid-upload',
  help: 'regular-circle-question',
  sort: 'solid-arrow-down-wide-short',
  collapse: 'solid-chevron-up',
  expand: 'solid-chevron-down',
  edit: 'regular-pen-to-square',
  lock: 'regular-lock',
  unlock: 'regular-lock-open',
  published: 'regular-eye',
  unpublish: 'regular-eye-slash',
  settings: 'regular-sliders',
  columns: 'regular-columns-3',
  add: 'regular-plus',
  close: 'regular-xmark',
  pin: 'regular-thumbtack',
});
